import 'sass/app.scss';

import _ from 'lodash';
import React from 'react';
import { HashRouter, Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { 
    FanLanding, 
    FanLandingMobile, 
    ArtistLanding, 
    ArtistLandingMobile, 
    LandingSelect, 
    LandingSelectMobile,
    LandingSingle
} from './landing';
import { ComingSoon } from './coming-soon';
import { ArtistSignUpForm, FanSignUpForm } from './sign-up';

import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { ToastContainer } from 'react-toastify';
import {isMobile} from 'react-device-detect';
import TermsOfUse from './terms/terms-conditions';
import PrivacyPolicy from './terms/privacy-policy';
import LicenseAgreement from './terms/license-agreement';
import LoginRoot from './login-root';
import { SessionWarningModal } from 'client/shared/components';
const AnimatedTransition = () => {
    let location = useLocation();

    return (
        <div>
            <TransitionGroup>
                <CSSTransition key={location.pathname} classNames="screenfade" timeout={600}>
                    <Switch location={location}>
                        <Route path="/artists" render={() => <ArtistLanding/> }/>
                        <Route path="/artists-mobile" render={() => <ArtistLandingMobile/> }/>
                        <Route path="/fans" render={() => <FanLanding/> }/>
                        <Route path="/fans-mobile" render={() => <FanLandingMobile/> }/>
                        <Route path="/user-terms" render={() => <TermsOfUse/> }/>
                        <Route path="/user-privacy-policy" render={() => <PrivacyPolicy/> }/>
                        <Route path="/user-license-agreement" render={() => <LicenseAgreement/> }/>
                        <Route path="/login" render={() => <LoginRoot/> }/>
                        <Route exact path="/" render={() => {
                            if (isMobile) return (<LandingSelectMobile/>);
                            return (
                                <LandingSingle/>
                            )
                        } }/>
                        {/* <Route path="/submissions/artist/:_id" component={ wrapGrid(ViewAudition) } /> */}
                    </Switch>
                </CSSTransition>
            </TransitionGroup>
        </div>
    );
}

export class Root extends React.Component {
	constructor (props) {
		super(props);
	}

	render () {
        return (
            <div style={{'backgroundColor': 'white'}}>
                <HashRouter>
                    <Switch>
                        <Route path="/artist-sign-up" render={() => <ArtistSignUpForm/> }/>
                        <Route path="/fan-sign-up" render={() => <FanSignUpForm/> }/>

                        <Route path="/coming-soon" render={() => <ComingSoon/> }/>
                        <Route path="*">
                            <AnimatedTransition />
                        </Route>
                    </Switch>
                </HashRouter>

                <ToastContainer />
                <SessionWarningModal />
            </div>
        );
	}
}

export default Root;
